import React from 'react'

import { css } from '@emotion/core'

import NewTypography from 'components/common/atoms/NewTypography'
import Container from 'components/layouts/atoms/Container'

const kampuspediaHeaderStyle = css`
  .kampuspedia-header {
    &__greeting {
      padding: 24px 16px;
      background-color: transparent;
    }
    &__title {
      margin-bottom: 16px;
    }
    @media screen and (min-width: 768px) {
      &__greeting {
        padding: 16px 0 0 0;
      }
    }
  }
`

const KampuspediaHeader = () => {
  return (
    <div className="kampuspedia-header" css={kampuspediaHeaderStyle}>
      <Container isMobileFull>
        <div className="kampuspedia-header__greeting">
          <NewTypography
            tagName="h1"
            variant="heading"
            level="1"
            variantPC="title"
            levelPC="3"
            className="kampuspedia-header__title"
          >
            Kampuspedia
          </NewTypography>
          <NewTypography tagName="h2" variant="paragraph" level="2" levelPC="1">
            Sumber terpercaya seputar istilah dunia perkuliahan.
          </NewTypography>
          <NewTypography tagName="h2" variant="paragraph" level="2" levelPC="1">
            Temukan istilah yang kamu tidak tahu di sini!
          </NewTypography>
        </div>
      </Container>
    </div>
  )
}

export default KampuspediaHeader
